export default class DespachoReporteQuery 
{
    desde!: string;
    hasta!: string;
    plantaId!: number;
    haciendaId:Array<number> = [];
    numeroDespacho:string="";
}